import { cn } from '@virginexperiencedays/tailwind';

import { BodyText } from '../../../typography/BodyText';

import { QuantityInput } from './QuantityInput';
import { AddToBasket } from '.';

export type BasketAddQuantityProps = {
  className?: string;
  dataTestId?: string;
  addToBasket: () => void;
  increment: () => void;
  decrement: () => void;
  qty: number;
  outOfStock: boolean;
  error: boolean;
  withQty?: boolean;
  isActive: boolean;
};

export const BasketAddQuantity = ({
  className,
  error,
  isActive,
  withQty = true,
  dataTestId = 'basket-add-quantity',
  qty = 1,
  outOfStock = false,
  increment = () => null,
  decrement = () => null,
  addToBasket = () => null,
}: BasketAddQuantityProps) => {
  return (
    <>
      <div className={cn('flex h-14', className)} data-testid={dataTestId}>
        {withQty && (
          <QuantityInput
            incrementQty={increment}
            decrementQty={decrement}
            disabled={outOfStock || !isActive}
            qty={qty}
          />
        )}

        <AddToBasket onClick={addToBasket} disabled={outOfStock || !isActive} />
      </div>
      {error && (
        <BodyText className="text-tones-critical-500 mt-2">
          Something went wrong, please try again
        </BodyText>
      )}
    </>
  );
};
